import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import timeUtils from '@/utils/time.js';
Vue.use(_Popup);
export default {
  data: function data() {
    return {};
  },
  computed: {
    onSaleTimeInfo: function onSaleTimeInfo() {
      var start = this.start;
      var _timeUtils$formatOnSa = timeUtils.formatOnSaleTime(start),
        onSaleTimeInfo = _timeUtils$formatOnSa.onSaleTimeInfo;
      return onSaleTimeInfo;
    }
  },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    start: {
      type: Number
    }
  },
  components: {},
  methods: {}
};